import { useInvoicesItemFormPageContext } from "@web-src/modules/invoices/pages/InvoicesItemFormPage/context/useInvoicesItemFormPageContext";
import { priceDisplay } from "@jugl-web/utils";
import { caltItemPrice } from "@jugl-web/domain-resources/invoices/utils";
import { InvoiceLineItem } from "@jugl-web/rest-api";
import { FC } from "react";

export const AmountCell: FC<{ item: InvoiceLineItem }> = ({ item }) => {
  const { currencySymbol, formValues } = useInvoicesItemFormPageContext();

  const finalQuantity = item?.qty ?? 0;
  const finalPrice = item?.price || 0;

  const total = caltItemPrice({
    price: finalPrice * 100,
    qty: Number(finalQuantity),
  });

  return (
    <div className="flex h-full items-center gap-2">
      <span className="font-primary text-[#828282]">{currencySymbol}</span>
      <span className="-mr-3 block truncate text-dark-800">
        {priceDisplay(total, formValues.currency, true)}
      </span>
    </div>
  );
};
